/*Header */
/*scroll header*/
$(window).scroll(function () {
	if ($(document).scrollTop() > 80) {
		$(".header_wrapper").addClass("scrolled");
	} else {
		$(".header_wrapper").removeClass("scrolled");
	}
});

/*Detect Direction*/
var lastScrollTop = 0;
$(window).scroll(function (event) {
	var st = $(this).scrollTop();
	if (st > lastScrollTop) {
		// downscroll code
		$(".header_wrapper").addClass("down");
	} else {
		// upscroll code
		$(".header_wrapper").removeClass("down");
	}
	lastScrollTop = st;
});

/*Language Switcher*/
$(".language.is-active").on("click", function () {
	return false;
});

/*Open Menu*/
$(".menu_open button").on("click", function () {
	if ($(this).hasClass("is-active")) {
		$("body").css("overflow-y", "scroll");
		$(this).removeClass("is-active");
		$(".headermenu").removeClass("is-active");
		$(".header_wrapper").removeClass("openmenu");
		$(".menu li").removeClass("aos-animate");
		$(".menu .is-active").removeClass("is-active");
	} else {
		$(this).addClass("is-active");
		jQuery("body").css("overflow-y", "hidden");
		$(".headermenu").addClass("is-active");
		$(".header_wrapper").addClass("openmenu");
		setTimeout(function () {
			$(".menu li").each(function (index) {
				$(this).addClass("aos-animate");
				$(this).addClass("aos-init");
			});
		}, 1000);
	}
});

/*Menu Animation*/
$(document).ready(function () {
	$(".menu > li").each(function (index) {
		$(this).attr("data-aos", "fade-up");
		$(this).attr("data-aos-duration", "600");
		$(this).addClass("aos-init");
		setTimeout(function () {
			$(".menu li").removeClass("aos-animate");
		}, 300);
		if (index == 0) {
			$(this).attr("data-aos-delay", 100);
		} else {
			$(this).attr("data-aos-delay", index * 150);
		}
	});
});

/*Gallery*/
import Swiper, { Navigation } from "swiper";
const gallery_swi = new Swiper(".gallery_swipe", {
	slidesPerView: "1",
	centeredSlides: false,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

/*Slider Rooms Section Homepage*/
const rooms_swi = new Swiper(".room_swipe", {
	slidesPerView: "3",
	centeredSlides: false,
	breakpoints: {
		0: {
			slidesPerView: "1",
			centeredSlides: false,
		},
		768: {
			slidesPerView: "2",
			centeredSlides: false,
		},
		1025: {
			slidesPerView: "3",
			centeredSlides: false,
		},
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

const subMenuBtns = document.querySelectorAll(".menu-item-has-children");
subMenuBtns.forEach((btn) => {
	btn.addEventListener("click", () => {
		btn.querySelector(".sub-menu").classList.toggle("is-active");
		btn.firstElementChild.classList.toggle("is-active");
		if (window.innerWidth < 768) {
			document.querySelector(".headermenu").classList.toggle("sub-open");
		}
	});
});

// Homepage Villa Swiper
const homepageExperienceSwiper = new Swiper(".homepage-villa-slider", {
	slidesPerView: "1",
	loop: false,

	// Navigation arrows
	navigation: {
		nextEl: ".arrow-button-prev",
		prevEl: ".arrow-button-next",
	},
});

if (document.querySelector(".homepage-villa-slider") != null) {
	homepageExperienceSwiper.on("slideChange", function () {
		document.querySelector(".current-index-villas").textContent =
			homepageExperienceSwiper.activeIndex + 1;
	});
	// Update swiper amount and title
	document.querySelector(".swiper-amount-villas").textContent =
		homepageExperienceSwiper.slides.length;
}

if ($(window).width() > 768) {
	$("#slider").on("click", function () {
		if ($(".slider_cursor").hasClass("left")) {
			homepageExperienceSwiper.slidePrev();
		} else {
			homepageExperienceSwiper.slideNext();
		}
	});

	$("#slider").mousemove(function (e) {
		var relX = e.pageX - $(this).offset().left;
		var relY = e.pageY - $(this).offset().top;
		var lSide = $(this).width() / 2;

		if (e.pageX < lSide) {
			$(".slider_cursor").addClass("left");
		} else {
			$(".slider_cursor").removeClass("left");
		}

		$(".slider_cursor").css({
			left: relX,
			top: relY,
		});
		$(".slider_cursor").addClass("active");
	});

	$("#slider").mouseleave(function () {
		$(".slider_cursor").removeClass("active");
	});

	// Remove 'active' class when hovering over an anchor tag, add it back when leaving
	$("#slider a").mouseenter(function () {
		$(".slider_cursor").addClass("hide");
		console.log("test1");
	});

	$("#slider a").mouseleave(function () {
		$(".slider_cursor").removeClass("hide");
		console.log("test2");
	});
}

const hero_swi = new Swiper(".hero_swipe", {
	slidesPerView: "1",
	centeredSlides: false,
	autoplay: {
		delay: 5000,
	},
	loop: true,
	navigation: {
		nextEl: ".hero-swiper-button-next",
		prevEl: ".hero-swiper-button-prev",
	},
});

const testimonialsSwiper = new Swiper(".testimonials-swiper", {
	slidesPerView: "1.75",
	centeredSlides: true,
	spaceBetween: 50,
	autoplay: {
		delay: 5000,
	},
	speed: 1000,
	// loop: true,
	breakpoints: {
		0: {
			slidesPerView: "1.25",
			spaceBetween: 20,
		},
		450: {
			slidesPerView: "1.5",
			spaceBetween: 30,
		},
		768: {
			slidesPerView: "1.75",
		},
	},
	navigation: {
		nextEl: ".testimonials-swiper-button-next",
		prevEl: ".testimonials-swiper-button-prev",
	},
});

document.addEventListener("DOMContentLoaded", () => {
	const tempText = document.getElementById("temp");
	const latitude = "35.5040592";
	const longitude = "23.9222132";

	const apiUrl = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m`;

	fetch(apiUrl)
		.then((response) => response.json())
		.then((data) => {
			const { current } = data;
			const CurrentTemperature = current.temperature_2m;
			const weatherContent = `${Math.round(CurrentTemperature)}&deg`;

			tempText.innerHTML = weatherContent;
		})
		.catch((error) => {
			console.error("Error fetching weather data:", error);
		});
});
